import { render } from "./bmsProjectCompletion.vue?vue&type=template&id=95e8ba56&scoped=true"
import script from "./bmsProjectCompletion.vue?vue&type=script&lang=js"
export * from "./bmsProjectCompletion.vue?vue&type=script&lang=js"

import "./bmsProjectCompletion.vue?vue&type=style&index=0&id=95e8ba56&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e8ba56"]])

export default __exports__